import { Observable } from 'rxjs';
import { UserProfile } from './user';

export abstract class UsersStore {
  abstract getAllUsers(): Observable<UserProfile>;
  abstract addNewUser(login: string, password: string, otherUsers: string[]): Observable<boolean>;
  abstract deleteUser(login: string): Observable<boolean>;
  abstract changeUserPassword(login: string, newPassword: string): Observable<boolean>;
  abstract changeAdminPassword(newPassword: string): Observable<boolean>;
  abstract getUser(login: string): Observable<UserProfile | null>;
  abstract setProfile(profile: UserProfile): Observable<boolean>;
  abstract updateLastLogin(login: string): Observable<boolean>;
}
